import {isExternalLink, toExternalUrl} from '../../utils/utils'

import {Link} from "gatsby";
import React from "react";

const PolyLink = React.memo(function PolyLink({
    children, url, target, style, className, name, notFocus, id, ariaLabel
}) {
    const conditionalAttrLink = {}

    if (id) {
        conditionalAttrLink.id = id;
    }

    if (target) {
        conditionalAttrLink.target = target;
    }

    if (!url) {
        return (
            <span className={className}>
                {children}
            </span>
        )
    }
    if (url !== "#" && !isExternalLink(url)) {
        return (
            <Link
                {...conditionalAttrLink}
                tabIndex={notFocus ? -1 : ""}
                to={url}
                style={style}
                className={className}
                aria-label={ariaLabel}
            >
                {children}
            </Link>
        );
    }

    return (
        <a
            {...conditionalAttrLink}
            tabIndex={notFocus ? -1 : ""}
            href={toExternalUrl(url)}
            rel="noopener noreferrer"
            style={style}
            className={className}
            aria-label={ariaLabel}
        >
            {children}
        </a>
    )
});

export default PolyLink;
